import { render } from "./IconWarning.vue?vue&type=template&id=fed35594"
import script from "./IconWarning.vue?vue&type=script&lang=js"
export * from "./IconWarning.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/miniapp-meter-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/assets/js/components/Icons/Icons/24/IconWarning.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "fed35594"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('fed35594', __exports__)) {
    api.reload('fed35594', __exports__)
  }
  
  module.hot.accept("./IconWarning.vue?vue&type=template&id=fed35594", () => {
    api.rerender('fed35594', render)
  })

}


export default __exports__